"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYLOAD_SENSITIVE_PLACE_EVENTS = exports.isProtectedServerPlaceEvent = exports.isPublicServerPlaceEvent = exports.ProtectedServerPlaceEvent = exports.PublicServerPlaceEvent = void 0;
var PublicServerPlaceEvent;
(function (PublicServerPlaceEvent) {
    PublicServerPlaceEvent["activateAccount"] = "activateAccount";
    PublicServerPlaceEvent["activatePlace"] = "activatePlace";
    PublicServerPlaceEvent["enableReservations"] = "enableReservations";
    PublicServerPlaceEvent["enableGuestWeb"] = "enableGuestWeb";
    PublicServerPlaceEvent["updatePlaceUserDeletionRequestedAt"] = "updatePlaceUserDeletionRequestedAt";
    PublicServerPlaceEvent["authenticatePlace"] = "authenticatePlace";
    PublicServerPlaceEvent["companyRegistration"] = "companyRegistration";
    PublicServerPlaceEvent["createFeedback"] = "createFeedback";
    PublicServerPlaceEvent["forgotPassword"] = "forgotPassword";
    PublicServerPlaceEvent["getEmployeeInvitation"] = "getEmployeeInvitation";
    PublicServerPlaceEvent["getPlaceActivation"] = "getPlaceActivation";
    PublicServerPlaceEvent["employeeRegistration"] = "employeeRegistration";
    PublicServerPlaceEvent["resetPassword"] = "resetPassword";
    PublicServerPlaceEvent["verifyPlaceToken"] = "verifyPlaceToken";
    PublicServerPlaceEvent["getReservationRequestAnswer"] = "getReservationRequestAnswer";
    PublicServerPlaceEvent["assignTable"] = "assignTable";
    PublicServerPlaceEvent["confirmReservation"] = "confirmReservation";
})(PublicServerPlaceEvent || (exports.PublicServerPlaceEvent = PublicServerPlaceEvent = {}));
var ProtectedServerPlaceEvent;
(function (ProtectedServerPlaceEvent) {
    ProtectedServerPlaceEvent["acceptReservation"] = "acceptReservation";
    ProtectedServerPlaceEvent["addEmployee"] = "addEmployee";
    ProtectedServerPlaceEvent["cancelReservation"] = "cancelReservation";
    ProtectedServerPlaceEvent["changePassword"] = "changePassword";
    ProtectedServerPlaceEvent["createContact"] = "createContact";
    ProtectedServerPlaceEvent["createLayout"] = "createLayout";
    ProtectedServerPlaceEvent["createNotification"] = "createNotification";
    ProtectedServerPlaceEvent["createPlace"] = "createPlace";
    ProtectedServerPlaceEvent["createPlaceLocalization"] = "createPlaceLocalization";
    ProtectedServerPlaceEvent["createPlaceProfile"] = "createPlaceProfile";
    ProtectedServerPlaceEvent["createReservation"] = "createReservation";
    ProtectedServerPlaceEvent["createReservationSetting"] = "createReservationSetting";
    ProtectedServerPlaceEvent["createTableType"] = "createTableType";
    ProtectedServerPlaceEvent["deleteCompany"] = "deleteCompany";
    ProtectedServerPlaceEvent["deleteContact"] = "deleteContact";
    ProtectedServerPlaceEvent["deleteEmployee"] = "deleteEmployee";
    ProtectedServerPlaceEvent["deleteLayout"] = "deleteLayout";
    ProtectedServerPlaceEvent["deleteNotification"] = "deleteNotification";
    ProtectedServerPlaceEvent["deletePlace"] = "deletePlace";
    ProtectedServerPlaceEvent["deletePlaceLocalization"] = "deletePlaceLocalization";
    ProtectedServerPlaceEvent["deletePlaceProfile"] = "deletePlaceProfile";
    ProtectedServerPlaceEvent["deleteReservation"] = "deleteReservation";
    ProtectedServerPlaceEvent["deleteReservationSetting"] = "deleteReservationSetting";
    ProtectedServerPlaceEvent["deleteTableType"] = "deleteTableType";
    ProtectedServerPlaceEvent["geocode"] = "geocode";
    ProtectedServerPlaceEvent["getAvailableLayoutTypes"] = "getAvailableLayoutTypes";
    ProtectedServerPlaceEvent["getCompany"] = "getCompany";
    ProtectedServerPlaceEvent["getContact"] = "getContact";
    ProtectedServerPlaceEvent["getCountries"] = "getCountries";
    ProtectedServerPlaceEvent["getEmployees"] = "getEmployees";
    ProtectedServerPlaceEvent["getFacebookPage"] = "getFacebookPage";
    ProtectedServerPlaceEvent["getFacebookPages"] = "getFacebookPages";
    ProtectedServerPlaceEvent["getLayouts"] = "getLayouts";
    ProtectedServerPlaceEvent["getLoggedInUser"] = "getLoggedInUser";
    ProtectedServerPlaceEvent["getNotifications"] = "getNotifications";
    ProtectedServerPlaceEvent["getHours"] = "getHours";
    ProtectedServerPlaceEvent["getPlace"] = "getPlace";
    ProtectedServerPlaceEvent["getPlaceLayouts"] = "getPlaceLayouts";
    ProtectedServerPlaceEvent["getPlaceLocalization"] = "getPlaceLocalization";
    ProtectedServerPlaceEvent["getPlaceProfile"] = "getPlaceProfile";
    ProtectedServerPlaceEvent["getReservation"] = "getReservation";
    ProtectedServerPlaceEvent["getReservations"] = "getReservations";
    ProtectedServerPlaceEvent["getReservationSeating"] = "getReservationSeating";
    ProtectedServerPlaceEvent["getReservationSetting"] = "getReservationSetting";
    ProtectedServerPlaceEvent["getTableTypes"] = "getTableTypes";
    ProtectedServerPlaceEvent["inviteEmployees"] = "inviteEmployees";
    ProtectedServerPlaceEvent["joinRoom"] = "joinRoom";
    ProtectedServerPlaceEvent["rejectReservation"] = "rejectReservation";
    ProtectedServerPlaceEvent["resolveReservation"] = "resolveReservation";
    ProtectedServerPlaceEvent["saveFacebookPage"] = "saveFacebookPage";
    ProtectedServerPlaceEvent["addSpecialHour"] = "addSpecialHour";
    ProtectedServerPlaceEvent["modifySpecialHour"] = "modifySpecialHour";
    ProtectedServerPlaceEvent["deleteSpecialHour"] = "deleteSpecialHour";
    ProtectedServerPlaceEvent["notificationWasShown"] = "notificationWasShown";
    ProtectedServerPlaceEvent["updateCompany"] = "updateCompany";
    ProtectedServerPlaceEvent["updateCompanyEmail"] = "updateCompanyEmail";
    ProtectedServerPlaceEvent["updateContact"] = "updateContact";
    ProtectedServerPlaceEvent["updateEmployee"] = "updateEmployee";
    ProtectedServerPlaceEvent["updateEmployeeEmail"] = "updateEmployeeEmail";
    ProtectedServerPlaceEvent["updateLayout"] = "updateLayout";
    ProtectedServerPlaceEvent["createDefaultHours"] = "createDefaultHours";
    ProtectedServerPlaceEvent["updateHours"] = "updateHours";
    ProtectedServerPlaceEvent["updatePlace"] = "updatePlace";
    ProtectedServerPlaceEvent["updatePlaceProfile"] = "updatePlaceProfile";
    ProtectedServerPlaceEvent["updateReservation"] = "updateReservation";
    ProtectedServerPlaceEvent["updateReservationEvent"] = "updateReservationEvent";
    ProtectedServerPlaceEvent["updateReservationGuest"] = "updateReservationGuest";
    ProtectedServerPlaceEvent["updateReservationSetting"] = "updateReservationSetting";
    ProtectedServerPlaceEvent["updatePlaceUserSelectedLanguage"] = "updatePlaceUserSelectedLanguage";
    ProtectedServerPlaceEvent["updatePlaceUserDeletionRequestedAt"] = "authenticatedUpdatePlaceUserDeletionRequestedAt";
    ProtectedServerPlaceEvent["createCheckoutSession"] = "createCheckoutSession";
    ProtectedServerPlaceEvent["getPrices"] = "getPrices";
    ProtectedServerPlaceEvent["getSubscriptions"] = "getSubscriptions";
    ProtectedServerPlaceEvent["cancelSubscription"] = "cancelSubscription";
    ProtectedServerPlaceEvent["changeSubscriptionPricing"] = "changeSubscriptionPricing";
    ProtectedServerPlaceEvent["getCompanyGuests"] = "getCompanyGuests";
})(ProtectedServerPlaceEvent || (exports.ProtectedServerPlaceEvent = ProtectedServerPlaceEvent = {}));
const publicServerPlaceEventSet = new Set(Object.values(PublicServerPlaceEvent));
const protectedServerPlaceEventSet = new Set(Object.values(ProtectedServerPlaceEvent));
const isPublicServerPlaceEvent = (event) => publicServerPlaceEventSet.has(event);
exports.isPublicServerPlaceEvent = isPublicServerPlaceEvent;
const isProtectedServerPlaceEvent = (event) => protectedServerPlaceEventSet.has(event);
exports.isProtectedServerPlaceEvent = isProtectedServerPlaceEvent;
exports.PAYLOAD_SENSITIVE_PLACE_EVENTS = new Set([
    PublicServerPlaceEvent.resetPassword,
    ProtectedServerPlaceEvent.changePassword,
    PublicServerPlaceEvent.authenticatePlace,
]);
//# sourceMappingURL=ServerPlaceEvent.js.map